export function getPropOrDefault(obj, prop, def) {
    return prop in obj ? obj[prop] : def;
}